// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const voen: CountryValidator<"AZ"> = createValidator(
  "az.voen",
  15,
);

export default voen;
export const compact = voen.compact;
export const format = voen.format;
export const validate = voen.validate;
export const generate = (): string =>
  voen.generate?.() ??
  (() => {
    throw new Error(
      "Validator az.voen cannot generate values",
    );
  })();
